export const keyToNote = {
  z: "c",
  s: "df",
  x: "d",
  d: "ef",
  c: "e",
  v: "f",
  g: "gf",
  b: "g",
  h: "af",
  n: "a",
  j: "bf",
  m: "b",
  ",": "c2",
  l: "df2",
  ".": "d2",
  ";": "ef2",
  "/": "e2",
};

export const noteToKey = {
  c: "z",
  df: "s",
  d: "x",
  ef: "d",
  e: "c",
  f: "v",
  gf: "g",
  g: "b",
  af: "h",
  a: "n",
  bf: "j",
  b: "m",
  c2: ",",
  df2: "l",
  d2: ".",
  ef2: ";",
  e2: "/",
};

export const notes2 = {
  c: "c",
  df: "c#",
  d: "d",
  ef: "d#",
  e: "e",
  f: "f",
  gf: "f#",
  g: "g",
  af: "g#",
  a: "a",
  bf: "a#",
  b: "b",
  c2: "c2",
  df2: "c2#",
  d2: "d2",
  ef2: "d2#",
  e2: "e2",
};
